import type { UserWithBranch, UserWithBranchesGroup } from '@/components/Views/Company/File/file.types';

export const groupUsersByIdWithBranches = (users: UserWithBranch[]): UserWithBranchesGroup[] => {
    const grouped = users.reduce<Record<UserWithBranch['id'], UserWithBranchesGroup>>((acc, user) => {
        if (!acc[user.id]) {
            acc[user.id] = {
                ...user,
                id: user.id.toString(),
                value: user.id.toString(),
                label: user.name,
                tooltipText: user.email,
                branches: [],
            };
        }
        acc[user.id].branches.push(user.branch_id);
        return acc;
    }, {});
    return Object.values(grouped);
};
